module.exports = __webpack_public_path__ + "img/undraw_content_structure.ec7f510c.svg";